import fp from 'lodash/fp';
import * as modules from './modules';

export const actions = fp.flow(
  fp.keys,
  fp.map((key) => fp.get(key, modules).action),
  fp.filter(fp.identity)
)(modules);

const rootAction = fp.assignAll(actions);

export default rootAction;



// WEBPACK FOOTER //
// ./src/state/actions.js